export default __webpack_public_path__ + "static/images/rank_nums_03.png";